import * as React from "react";
import SearchBar from "./SearchBar";
import NavigationIcons from "./NavigationIcons";
import UserProfile from "./UserProfile";
import Icon15 from "../img/a6fbc02e1270717ab963b6d5928edcec5bb01a1174b13c49daba957378db2aa2.png";
import Icon16 from "../img/a7f7a9592672dc8292b64fc8b2835b0d8bc8d3fda03c89b24078f79b1ba85c61.svg";

function Header() {
  return (
    <header className="flex-row flex-wrap gap-5 p-7 w-full bg-white shadow-[0px_4px_20px_rgba(0,0,0,0.1)] max-md:px-5 max-md:max-w-full max-sm:flex-col max-sm:gap-4 max-sm:justify-center max-sm:items-center max-sm:p-4 max-sm:w-full">
      <div className="flex gap-5 max-md:flex-col">
        <nav className="flex flex-col w-[14%] max-md:ml-0 max-md:w-full">
          <div className="flex grow gap-8 items-center self-stretch my-auto text-xl font-medium whitespace-nowrap text-neutral-700 max-md:mt-10">
            <img
              loading="lazy"
              src={Icon15}
              className="object-contain shrink-0 self-stretch max-w-full aspect-[3.17] w-[146px]"
              alt="SharePoint Logo"
            />
          </div>
        </nav>
        <section className="flex flex-col ml-5 w-[81%] max-md:ml-0 max-md:w-full">
          <div className="flex flex-wrap gap-5 justify-end w-full max-md:mt-10 max-md:max-w-full">
            <SearchBar />
            <div className="flex flex-wrap gap-8 items-center self-start max-md:max-w-full">
              <NavigationIcons />
              <div className="shrink-0 self-stretch my-auto w-0 border border-white border-solid h-[18px]" />
              <UserProfile />
            </div>
          </div>
        </section>
      </div>
    </header>
  );
}

export default Header;